import axios from 'axios';
import http from './http';

const prefix = '/api/manage';

export const getUser = () => http.get(`${prefix}/user`);
/**
 * 获取图片上传凭证
 */
export const getBucketToken = () => http.get(`${prefix}/getBucketToken`);

// 获取国家列表
export const getCountries = params => http.get(`${prefix}/country`, { params });

// 新增国家
export const createCountry = data => http.post(`${prefix}/country`, data);

// 更新国家
export const updateCountry = (data, id) => http.put(`${prefix}/country/${id}`, data);

// 获取国家详情
export const getCountry = id => http.get(`${prefix}/country/${id}`);

// 删除国家
export const delCountry = id => http.delete(`${prefix}/country/${id}`);

// 获取国家城市列表
export const getCities = params => http.get(`${prefix}/city`, { params });

// 新增城市
export const createCity = data => http.post(`${prefix}/city`, data);

// 更新城市
export const updateCity = (data, id) => http.put(`${prefix}/city/${id}`, data);

// 获取城市详情
export const getCity = id => http.get(`${prefix}/city/${id}`);

// 删除城市
export const delCity = id => http.delete(`${prefix}/city/${id}`);

// 获取文章列表
export const getArticles = params => http.get(`${prefix}/article`, { params });

// 删除文章
export const delArticle = id => http.delete(`${prefix}/article/${id}`);

// 新建文章
export const createArticle = data => http.post(`${prefix}/article`, data);

// 更新文章
export const updateArticle = (data, id) => http.put(`${prefix}/article/${id}`, data);

// 获取文章详情
export const getArticleDetail = id => http.get(`${prefix}/article/${id}`);

// 获取职位列表
export const getJobList = params => http.get(`${prefix}/job`, { params });

// 删除职位
export const delJob = id => http.delete(`${prefix}/job/${id}`);

// 新建职位
export const createJob = data => http.post(`${prefix}/job`, data);

// 更新职位
export const updateJob = (data, id) => http.put(`${prefix}/job/${id}`, data);

// 获取职位详情
export const getJobDetail = id => http.get(`${prefix}/job/${id}`);

export const uploadImage = (formData, success, failure) => {
  axios('https://bfs.bigo.sg/file/new?bucket=bigo-official', {
    method: 'post',
    data: formData,
    requestType: 'form',
    credentials: 'omit',
  })
    .then((res) => {
      if (res && res.status === 200) {
        success(res.data.url.replace(/^http:/, 'https:'));
      }
    })
    .catch(err => failure(err));
};
